import * as React from "react";

import { Wrapper, ContentRegion, TabletContentRegion } from "./overlay-modal-style";
import { isNullOrUndefined } from "util";
import { withDefault } from "collection-utils";
import type { RenderEnvironment } from "common/components/types";

interface Props {
    dismissed: boolean;
    onAnimationEnd: () => void;
    zIndex?: number;
    renderEnvironment: RenderEnvironment;
}

interface State {
    introDone: boolean;
}

export default class OverlayModal extends React.PureComponent<Props, State> {
    public state: State = {
        introDone: false,
    };

    private contentRef = React.createRef<any>();

    public componentDidMount() {
        this.hookAnimationCallback();
    }

    public componentWillUpdate(_nextProps: Props, _nextState: any): void {
        this.unhookAnimationCallback();
    }

    public componentDidUpdate(_prevProps: Props, _prevState: any): void {
        this.hookAnimationCallback();
    }

    public componentWillUnmount(): void {
        this.unhookAnimationCallback();
    }

    private onAnimationEnd = () => {
        if (!this.state.introDone) {
            this.setState({ introDone: true });
        }
        this.props.onAnimationEnd();
    };

    private hookAnimationCallback(): void {
        if (isNullOrUndefined(this.contentRef.current)) return;

        this.contentRef.current.addEventListener("animationend", this.onAnimationEnd);
    }

    private unhookAnimationCallback(): void {
        if (isNullOrUndefined(this.contentRef.current)) return;

        this.contentRef.current.addEventListener("animationend", this.onAnimationEnd);
    }
    public render(): React.ReactNode {
        const { renderEnvironment } = this.props;

        const style: React.CSSProperties = {
            zIndex: withDefault(this.props.zIndex, 0),
        };

        const isTablet = renderEnvironment.sizeClass === "tablet";
        let CR = ContentRegion;
        if (isTablet) {
            CR = TabletContentRegion;
        }

        return (
            <Wrapper style={style} tabletMode={isTablet}>
                <CR ref={this.contentRef} dismissed={this.props.dismissed} introDone={this.state.introDone}>
                    {this.props.children}
                </CR>
            </Wrapper>
        );
    }
}
